<template>
    <router-link v-if="!anchor" :to="'/produktkategorien/' + data.slug.name">
        <div class="rounded-md shadow-md hover:shadow-lg lg:transition hover:scale-105 flex flex-col justify-between card relative text-white cursor-pointer">
            <div class="p-4 flex flex-col justify-center items-center my-2">
                <div class="w-16 h-16 my-4">
                    <img :alt="$translate(data.name)" :src="data.image.replace('.png', '-white.png')" class="w-auto h-auto" />
                </div>
                <h3 class="large_normal">
                    {{ $translate(data.name) }}
                </h3>
                <p class="line-clamp-4 text-center mt-2 text-xs w-full">
                    {{ $translate(data.short_description) }}
                </p>
            </div>
            <FormButton styling="xl text-white w-full text-xs" :backgroundColor="data.background_color" :value="$t('plain_learn_more')"> </FormButton>
        </div>
    </router-link>
    <div
        v-else
        @click="$emit('jumpToCategory', data)"
        class="rounded-md shadow-md hover:shadow-lg lg:transition hover:scale-105 flex flex-col justify-between card relative text-white cursor-pointer"
    >
        <div class="p-4 flex flex-col justify-center items-center my-2">
            <div class="w-16 h-16 my-4">
                <img :alt="$translate(data.name)" :src="data.image.replace('.png', '-white.png')" class="w-auto h-auto" />
            </div>
            <h3 class="large_normal">
                {{ $translate(data.name) }}
            </h3>
            <p class="line-clamp-4 text-center mt-2 text-xs w-full">
                {{ $translate(data.short_description) }}
            </p>
        </div>
        <FormButton styling="xl text-white w-full text-xs" :backgroundColor="data.background_color" :value="$t('plain_learn_more')"> </FormButton>
    </div>
</template>

<script>
export default {
    props: {
        data: Object,
        anchor: Boolean
    },
    computed: {
        background() {
            return 'linear-gradient(to bottom, ' + this.data.background_color + ' 0%, ' + this.data.background_gradient + ' 100%)';
        }
    }
};
</script>

<style scoped>
.card {
    background: v-bind(background);
}
</style>
